module.exports = __webpack_public_path__ + "front/img/41.5a866178.png";